import Breadcrumb from './../../components/BreadCrumb';
import ServiceComponent from './../../components/ServiceComponent';
import HeadingDetailsSection from './../../sections/HeadingDetailsSection';
import { faCoins, faGears, faSquarePollVertical } from '@fortawesome/free-solid-svg-icons';
import image from './../../assets/pexels/litigation.jpg';

function LitigationSupportScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Litigation Support & E-Discovery'>
          <Breadcrumb parent="Services" screen='Litigation Support & E-Discovery'/>
        </HeadingDetailsSection>
        <ServiceComponent
          heading="Litigation Support & E-Discovery"
          description="Streamline your litigation process with PocketLPO’s Litigation Support & E-Discovery services. Our team ensures accurate and timely support to help you prepare for legal proceedings."
          services={[
            "Document review and case summarization.",
            "E-discovery services utilizing advanced technology.",
            "Legal transcription and analysis."
          ]}
          benefits={[
            { title: "Cost Savings", description: "Reduce litigation expenses with efficient processes.", icon: faCoins },
            { title: "Accuracy", description: "Access detailed and reliable case documentation.", icon: faSquarePollVertical },
            { title: "Technology Integration", description: "Utilize AI tools for e-discovery.", icon: faGears }
          ]}
          image={image}
        />
    </>
  );
}

export default LitigationSupportScreen;
